"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const _1 = require(".");
const react_router_1 = require("react-router");
exports.ChykPreloader = ({ children }) => {
    const chyk = _1.useChyk();
    const location = react_router_1.useLocation();
    const [, set_render_location] = react_1.useState(location); // just to rerender
    chyk.handleLocationChange(location).then(should_rerender => {
        should_rerender && set_render_location(location);
    });
    return react_1.default.createElement(react_router_1.Route, { location: chyk.locationState.location, render: () => children });
};
exports.ChykPreloader.displayName = "ChykPreloader";
//# sourceMappingURL=preloader.js.map